export default __webpack_public_path__ + "media/images/newrin-777333bedb81fa74fe0916905912ad9f.png";